import React from "react";
import logo from "../logo.svg";

function Header() {
  return (
    <header
      style={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#fff",
        padding: "20px 40px",// Increased padding for more space
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.36)",
      }}
    >
      <img
        src={logo}
        alt="UMSS Logo"
        style={{
          width: "150px",// Slightly smaller logo
          height: "auto",// Maintain aspect ratio
          marginRight: "20px",// More space between logo and any future elements
          objectFit: "contain",
        }}
      />
    </header>
  );
}

export default Header;